import { createSlice } from '@reduxjs/toolkit';
import apiClient from 'root/lib/apiClient';
import { Sentry } from 'root/utils/raven';

const initialState = {
  items: {},
  isLoading: false,
  error: null,
};

const sidebarsSlice = createSlice({
  name: 'sidebars',
  initialState,
  reducers: {
    getSidebarStart(state) {
      state.isLoading = true;
    },
    getSidebarSuccess(state, { payload: { slug, data } }) {
      state.items[slug] = data;
      state.isLoading = false;
      state.error = null;
    },
    getSidebarFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getSidebarStart,
  getSidebarSuccess,
  getSidebarFailure,
} = sidebarsSlice.actions;

export default sidebarsSlice.reducer;

export const fetchSidebar = (slug) => async (dispatch, getState) => {
  const { sidebars } = getState();
  if (sidebars.items[slug] && !sidebars.items[slug]?.length) {
    dispatch(getSidebarSuccess({
      slug,
      data: sidebars.items[slug],
    }));
  } else {
    try {
      dispatch(getSidebarStart());
      const data = await apiClient({ method: 'GET', url: `/wp-json/mc/v1/sidebars/${slug}` });
      dispatch(getSidebarSuccess({
        slug,
        data,
      }));
    } catch (e) {
      dispatch(getSidebarFailure(e.toString()));
      Sentry.captureException(e);
    }
  }
};

export const setSidebar = ({ slug, data }) => getSidebarSuccess({
  slug,
  data,
});
